/**
 * 回收站 store（资产库单一入口，纯前端软删除）。
 *
 * 删除 = 把资产标记进回收站（从资产库隐藏、可恢复）；彻底删除 = 从其来源画布移除节点。
 * 只存被删项的快照（key = canvasId:nodeId），localStorage 持久化。跨模块统一走这一处，不各自建回收站。
 */
import { create } from 'zustand';

export type TrashKind = 'media' | 'subject' | 'shot';

export interface TrashItem {
  key: string;
  canvasId: string;
  canvasTitle: string;
  nodeId: string;
  kind: TrashKind;
  label: string;
  thumb?: string | undefined;
  url?: string | undefined;
}

export function trashKey(canvasId: string, nodeId: string): string {
  return `${canvasId}:${nodeId}`;
}

const TRASH_KEY = 'videoai-pro.trash.v1';

function load(): TrashItem[] {
  if (typeof window === 'undefined') {
    return [];
  }
  try {
    const raw = window.localStorage.getItem(TRASH_KEY);
    const parsed: unknown = raw === null ? [] : JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as TrashItem[]) : [];
  } catch {
    return [];
  }
}
function persist(items: TrashItem[]): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(TRASH_KEY, JSON.stringify(items));
  } catch {
    /* 忽略配额异常 */
  }
}

interface TrashState {
  items: TrashItem[];
  add: (item: TrashItem) => void;
  restore: (key: string) => void;
  purge: (key: string) => void;
  clear: () => void;
}

export const useTrashStore = create<TrashState>()((set) => ({
  items: load(),
  add: (item) =>
    set((s) => {
      const items = [item, ...s.items.filter((x) => x.key !== item.key)];
      persist(items);
      return { items };
    }),
  restore: (key) =>
    set((s) => {
      const items = s.items.filter((x) => x.key !== key);
      persist(items);
      return { items };
    }),
  purge: (key) =>
    set((s) => {
      const items = s.items.filter((x) => x.key !== key);
      persist(items);
      return { items };
    }),
  clear: () => {
    persist([]);
    set({ items: [] });
  },
}));
